// extracted by mini-css-extract-plugin
export var fullWidth = "YoutubeVideo-module--fullWidth--wDS9g";
export var youtubeVideoWrapper = "YoutubeVideo-module--youtubeVideoWrapper--Qi9QQ";